import { type ClientResponse } from 'hono/client';

type JsonData<R> = R extends ClientResponse<infer T, any, 'json'> ? T : never;

export async function honoFetcher<R extends ClientResponse<unknown, number, string>>(
  resPromise: Promise<R>,
): Promise<JsonData<R>> {
  const res = await resPromise;

  if (res && !res.ok) {
    throw new Error(`Request failed: ${(await res.text()) || res.status}`);
  }

  return res.json() as Promise<JsonData<R>>;
}
